<template>
  <div class="skill-grid">
    <div class="button-wrapper">
      <button
        class="button"
        v-for="(entry, index) in filterList"
        :key="index"
        @click="setFilter(entry)"
      >
        {{ entry.toUpperCase() }}
      </button>
    </div>

    <transition-group tag="div" class="parent " name="skill-list">
      <div v-for="skill in filteredSkills" :key="skill.id">
        <Skill
          :name="skill.name"
          :icon="skill.icon"
          :awesome="skill.awesome"
          :key="skill.id"
        />
      </div>
    </transition-group>
  </div>
</template>

<script>
import Skill from '../components/Skill.vue';
import skillsData from '../data/skills.json';

export default {
  name: 'SkillsGrid',
  components: {
    Skill: Skill,
  },
  data() {
    return {
      skills: skillsData,
      fkey: 'category',
      filterList: ['code', 'design', 'film', 'all'],
      filter: 'all',
    };
  },
  computed: {
    filteredSkills: function() {
      var vm = this;
      var category = vm.filter;

      if (category === 'all') {
        return vm.skills;
      } else {
        return vm.skills.filter(function(skill) {
          return skill.category === category;
        });
      }
    },
  },
  methods: {
    setFilter: function(entry) {
      this.filter = entry;
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  color: var(--bg-secondary);
}

h3 {
  font-family: futura-pt, sans-serif;
}

.skill-grid {
  width: 100%;
  @include flex-center();
  flex-direction: column;
  justify-content: space-around;
  margin-bottom: 5rem;
}

.button-wrapper {
  @include flex-center();
  width: 80%;
  justify-content: center;
  margin: 2em 1em;
  flex-wrap: wrap;
}
.parent {
  width: 70%;

  display: flex;
  flex-wrap: wrap;
  align-items: center;
  align-content: flex-start;
  justify-content: center;
}

.skill-list-move {
  transition: transform 0.7s cubic-bezier(0.42, -0.56, 0.41, 1.37);
}

.skill-list-enter-to {
  -webkit-animation: scale-in-center 0.5s
    cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
  animation: scale-in-center 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
}

.skill-list-leave-to
/* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;

  // transform: scale(1.2);
}
.skill-list-leave-active {
  position: absolute;
}

/* ----------------------------------------------
 * Generated by Animista on 2020-4-15 12:14:13
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation scale-in-center
 * ----------------------------------------
 */
@-webkit-keyframes scale-in-center {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes scale-in-center {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }
}

@-webkit-keyframes scale-out-center {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
    opacity: 1;
  }
}
@keyframes scale-out-center {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
    opacity: 1;
  }
}

@media screen and (max-width: 576px) and (max-aspect-ratio: 1/1) {
  .parent {
    width: 75%;
  }

  .button-wrapper {
    width: 90%;
  }
}
</style>
